import * as React from "react";
import { useDispatch } from "react-redux";

import { cloneDeep } from "lodash";
import OverlaySpinner from "src/components/Loaders/OverlaySpinner";
import CompanyTable from "src/components/Tables/Companies/FullTable";
import { updateActiveFormInstance } from "../../../../store/base";
import {
  constants,
  destroyPatchForm,
  update,
  useParkingContractForm,
} from "../../../../store/parkingContracts";
import TableSelectField from "../../Base/Fields/TableSelectField";
import Modal from "../../Base/Modals/Modal";

export default function UpdateParkingContractLandlordModalForm({
  id,
  onCheckout,
  instance = {},
}) {
  const method = "PATCH"; // always patch
  const dispatch = useDispatch();
  const storeName = constants.STORE_NAME;
  const [loading, setLoading] = React.useState(false);

  const formLoaded = Boolean(useParkingContractForm(method, id));

  React.useEffect(() => {
    if (instance) {
      dispatch(
        updateActiveFormInstance({
          storeName: storeName,
          data: instance,
        })
      );
    }
  }, []);

  const preProcess = (data) => {
    const dataClone = cloneDeep(data);

    delete dataClone.editabledoc;

    return dataClone;
  };

  const checkout = (success) => {
    dispatch(destroyPatchForm(success));

    onCheckout();
  };

  const onSuccess = (_, returned) => {
    setLoading(false);
    checkout(true);
  };

  const onSubmit = () => {
    setLoading(true);

    dispatch(
      update({
        id,
        successCallback: onSuccess,
        preProcess: preProcess,
        errorCallback: () => setLoading(false),
      })
    );
  };

  const onDone = () => {
    checkout(false);
  };

  return (
    <Modal
      title="Uppdatera avtal"
      closeFunction={onDone}
      onAccept={onSubmit}
      acceptTitle="Spara"
    >
      {(loading || !formLoaded) && <OverlaySpinner />}
      <div className="grid grid-cols-2 gap-6 mb-6">
        <TableSelectField
          storeName={storeName}
          method={method}
          fieldKey="landlord"
          title={"Hyresvärd"}
          placeholder="Välj hyresvärd..."
          description="Bolaget som ska stå som hyresvärd på avtalet."
          TableComponent={CompanyTable}
        />
      </div>
    </Modal>
  );
}
